
<div class="container">
  <h1 class="title alt">{{data.title}}</h1>
  <h3 style="margin: 0; text-align: center;">{{data.subtitle}}</h3>
</div>

<div mat-dialog-actions style="display: flex; justify-content: center;">
  <button mat-dialog-close>Close</button>
</div>
